<template>
  <div v-if="livingOption && subsection && property" class="live-property">    
    <main-content
      right-sidebar="true"
    >
      <image-gallery 
        :autoplay="false" 
        :contain-images="false"
        :images="images" 
        :show-nav="true"
      />
      <!-- <div class="live-property__details-pane">
        <ul>
          <li>label: {{ property.label }}</li>
          <li>area m^2: {{ property.msq }}</li>
          <li>value: {{ property.price }}</li>
          <li>status: {{ property.status }}</li>
          <li>view: {{ property.view }}</li>
        </ul>
        <div class="live-property__models">
          <ul
            v-for="model in property.models"
            class="live-property__model"
            :key="model._id"
          >
            <li>{{ model.label }}</li>
            <li>{{ model.type }}</li> 
            <li>{{ model.beds }}</li>
            <li>images:
              <ul>
                <li v-for="path in model.images" :key="path">{{ path }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div> -->
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="`${livingOption.label[language.code]} - ${propertyNumber}`"
    >
      <div class="description" slot="description">
        <div class="property__subsection">
          {{ subsection.displayName[language.code] }}
        </div>
        <div class="property__label">
          Price
        </div>
        <div class="property__price">
          {{ priceFormatted }} OMR <span class="small">+VAT</span>
        </div>

        <div v-if="isPlotDisplayed" class="property__size-group">
          <div class="property__size-group-wrapper">
            <div class="property__label">
              Home Size
            </div>
            <div class="property__size">
              {{ property.msq }}<span>m<sup>2</sup></span>
            </div>
          </div>
          <div class="property__size-group-wrapper">
            <div class="property__label">
              Plot Size
            </div>
            <div class="property__size">
              {{ property.plotMsq }}<span>m<sup>2</sup></span>
            </div>
          </div>
        </div>
        
        <div v-if="!isPlotDisplayed" class="property__label">
          Size
        </div>
        <div v-if="!isPlotDisplayed" class="property__size">
          {{ property.msq }}<span>m<sup>2</sup></span>
        </div>

        <div class="property__label">
          View
        </div>
        <div class="property__size">
          {{ this.property.view }}
        </div>
        <div class="property__label">
          Features
        </div>        
        <div class="property__icon">
          <span><fa fixed-width :icon="['fad', 'bed']"/></span> {{ property.models[0].beds }}
        </div>     
          <!-- 
          <div class="property__icon">
            <span><fa fixed-width :icon="['fad', 'bath']"/></span> 2
          </div>    
          <div class="property__icon">
            <span><fa fixed-width :icon="['fad', 'car']"/></span> 1
          </div>
          -->
        <div class="property__favourites">
          <transition name="fast-fade">
            <div v-if="isFavouriteLimitShowing" class="favourites-warning">You've reached your favourites limit</div>
          </transition>
          <button v-if="!isFavourite" class="btn btn--gold" @click="favourites.length < 12 ? addToFavourites(property._id) : displayFavouritesLimitWarning()">Add to favourites</button>
          <button v-if="isFavourite" class="btn btn--red" @click="removeFromFavourites(property._id)">Remove from favourites</button>
          <router-link 
            class="btn btn--blue"
            tag="button"
            to="/live/favourites"
          >View favourites</router-link>
        </div>
      </div>
      <template slot="bottom-slot">
        <button class="right-sidebar__back" @click="$router.go(-1)"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</button>
        <div class="right-sidebar__search"></div>
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
// A subsection either links to properties or other subsections 
import ImageGallery from '@/components/ImageGallery'
import MainContent from '@/components/MainContent'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: { ImageGallery, MainContent, RightSidebar },

  data () {
    return {
      favouritesTimeout: null,
      isFavouriteLimitShowing: false
    }
  },

  computed: {
    ...mapGetters({
      livingOption: 'property/activeLivingOption',
      property: 'property/activeProperty',
      subsection: 'property/activeSubsection',
      favourites: 'favourites/favourites',
      language: 'language'
    }),

    isPlotDisplayed () {
      if (this.property.models[0].type === 'villa' || this.property.models[0].type === 'townhome' || this.property.models[0].type === 'palace') {
        return true
      } else {
        return false
      }
    },

    priceFormatted () {
      // Takes price and adds ',' every thousand
      let remaining = this.property.price.toString() // this string gets smaller as we loop over its length taking '000 off each loop
      let formatted = '' // this is the string that we add the formatted '000s to
      while (remaining.length > 3) { // 3 because '000 (thousand)
        formatted = ',' + remaining.substring(remaining.length - 3, remaining.length) + formatted // , + <last 3 digets> + <any already formatted digets> 
        remaining = remaining.substring(0, remaining.length - 3) // remove the last 3 digets from remaining
      }
      formatted = remaining + formatted // < 3 digets left so no more ',' to add
      return formatted
    },

    details () {
      return `
        
      `
    },

    images () {
      let images = []
      images.push(...this.property.images, ...this.property.models[0].floorplans, ...this.property.models[0].images)
      return images
    },

    propertyNumber () {
      return this.property.label.substring(this.property.label.indexOf('-') + 1)
    },

    isFavourite () {
      return _.find(this.favourites, favourite => { 
        return favourite.propertyId === this.property._id 
      })
    }
  },

  methods: {
    addToFavourites (propertyId) {
      const data = {
        propertyId: propertyId,
        subsectionId: this.subsection._id,
        livingId: this.livingOption._id
      }
      this.$store.commit('favourites/ADD_TO_FAVOURITES', data)
    },

    displayFavouritesLimitWarning () {
      if (this.favouritesTimeout) {
        clearTimeout(this.favouritesTimeout)
      }

      this.isFavouriteLimitShowing = true
      this.favouritesTimeout = setTimeout(() => {
        this.isFavouriteLimitShowing = false
      }, 3000);
    },

    removeFromFavourites (propertyId) {
      this.$store.commit('favourites/REMOVE_FROM_FAVOURITES', propertyId)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.live-property {
  font-family: $touchscreen-font;

  .ar & {
    font-family: 'GE Dinkum';
  }  

  .description {
    display: flex;
    flex-direction: column;
  }

  .property {
    &__subsection {
      font-size: 1.9rem;
      text-transform: uppercase;
      margin-top: -1.5rem;
      opacity: 0.7;
    }

    &__label {
      // color: $lblue;
      font-size: 1.5rem;
      text-transform: uppercase;
      margin-top: 2.5rem;
      opacity: 0.7;
    }

    &__icon {
      font-size: 3rem;
      margin-top: 1rem;
      span {
        font-size: 2.7rem;
        margin-right: 1rem;
      }
    }

    &__size-group {
      display: flex;
    }

    &__size-group-wrapper {
      margin-right: 2rem;
    }

    &__price, &__size {
      font-size: 2.2rem;

      span {
        font-size: 2rem;
        // opacity: 0.8;
        margin-left: 0.3rem;
      }

      .small {
        font-size: 1.4rem;
      }
    }

    &__favourites {
      margin: auto 0 0;
      position: relative;
      width: 26rem;

      .btn {
        color: $black;
        font-family: $touchscreen-font;
        font-size: 1.4rem;
        margin: 1rem 0 0;
        padding: 1rem 0 .8rem;
        text-transform: uppercase;
        width: 26rem;

        .ar & {
          font-family: 'GE Dinkum';
        }        

        &--gold {
          @include btn($gold, $gold);
        }

        &--red {
          @include btn($red, $red);
          color: $white;
        }

        &--blue {
          @include btn($ddblue, $ddblue);
          color: $white;
        }
      }
    }
  }

  .main-content {
    background-color: #fff;
  }
  
  &__details-pane {
    position: absolute;
    z-index: 9;
    color: black;
    font-size: 3rem;
  }

  &__models {
    display: flex;
    flex-wrap: wrap;
  }

  &__model {

  }
}

.favourites-warning {
  background: rgb(211, 32, 0);
  border-radius: .5rem;
  color: $white;
  display: inline-block;
  font-size: 1.2rem;
  left: 50%;
  padding: .5rem 1rem;
  position: absolute;
  top: -2.1rem;
  transform: translateX(-50%);
  width: max-content;

  &::after {
    border: 1rem solid transparent;
    border-top-color: rgb(211, 32, 0);
    position: absolute;
    content: '';
    left: 50%;
    bottom: -1.5em;
    transform: translateX(-50%);
  }
}
</style>